import { Product } from '../../../core/models/product.model';


export class ProductsNotesModel {
  type: string;
  price: number;
  isSelected = false;
  product: Product;
  text: string;

  get priceText() {
    return this.price.toFixed(2);
  }

  constructor(obj?: ProductsNotesModel) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
